module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_c('div', {
    staticClass: "head-modal row"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n\t\t\t\t\tNouveau message\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n\t\t\t\t\tRépondre à votre " + _vm._s((_vm.data.isAdvisor) ? 'client' : 'patrimofficer') + "\n\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui need-big"
  }, [_c('div', {
    staticClass: "form-elem-container in-modal"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-textarea ctn-label",
    class: {
      error: _vm.errors.has('body')
    }
  }, [_c('label', {
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    attrs: {
      "type": "text",
      "name": "body"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('body')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('body')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Envoyer")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f900a5b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/Modal/NewMessage.vue
// module id = 1130
// module chunks = 0